import { useState } from 'react';

import { ApolloError } from '@apollo/client';

import { ErrorMessage } from '../ErrorMessage';
import { Flex } from '../Flex';
import { IconButton } from '../IconButton';
import { Modal } from '../Modal';
import { StoreCard } from '../StoreCard';
import { Title } from '../Title';
import CLOSE from '../../assets/imgs/icon/close.svg';

import { Skeleton } from '../../Store/components/ListItem/Skeleton';
import { StoreFieldsFragment } from '../../Store/graphql';
import { StoreSelectionSource } from './type';
import { ZipCodeField } from '../ZipCodeField';

interface StoreSelectorProps {
	isOpen: boolean;
	forSettingOLOStore?: boolean;
	source?: StoreSelectionSource;
	showFavorite?: boolean;
	toggleHandler: () => void;
	buttonAction: (storeId: number) => void;
	onFavorite?: (storeId: number) => void;
	buttonText?: string;
}

export const StoreSelector: React.FC<StoreSelectorProps> = ({
	buttonText,
	isOpen,
	source,
	forSettingOLOStore,
	buttonAction,
	toggleHandler
}) => {
	const [searchValue, setSearchValue] = useState<number | string>();
	const [stores, setStores] = useState<StoreFieldsFragment[]>([]);
	const [submitted, setSubmitted] = useState<boolean>(false);
	const [error, setError] = useState<ApolloError>();
	const [loading, setLoading] = useState<boolean>(false);

	return (
		<Modal isOpen={isOpen} toggleHandler={toggleHandler} size="md">
			<Title>
				<Flex
					$flexDirection="row"
					$width="100%"
					$alignItems="center"
					$justifyContent="space-between"
				>
					Find a Store
					<IconButton url={CLOSE} alt="X" onClick={toggleHandler} />
				</Flex>
			</Title>
			<Flex $flexDirection="column" $rowGap="15px">
				<Flex
					$flexDirection="row"
					$alignItems="flex-end"
					$columnGap="8px"
				>
					<ZipCodeField
						onStores={stores => setStores(stores)}
						onRequestError={error => setError(error)}
						onLoading={loading => setLoading(loading)}
						onSubmitted={submitted => setSubmitted(submitted)}
						onSearchValue={inputText => setSearchValue(inputText)}
					></ZipCodeField>
				</Flex>

				{stores && submitted && (
					<Flex
						$flexDirection="column"
						style={{ borderTop: '1px solid #d9d9d9' }}
					>
						{stores.map((store: StoreFieldsFragment) => (
							<StoreCard
								key={store.storeId}
								store={store}
								forSettingOLOStore={forSettingOLOStore}
								source={source}
								toggleHandler={toggleHandler}
								buttonAction={() => buttonAction(store.storeId)}
								buttonText={buttonText}
							/>
						))}
					</Flex>
				)}
				{error && <ErrorMessage error={error}></ErrorMessage>}
				{loading && <Skeleton />}
				{!loading &&
					stores.length === 0 &&
					submitted &&
					searchValue && (
						<h2 className="alert-no-results">
							0 results for {searchValue}
						</h2>
					)}
				{!loading &&
					stores.length === 0 &&
					submitted &&
					!searchValue && (
						<h2 className="alert-no-results">0 results</h2>
					)}
			</Flex>
		</Modal>
	);
};
